import React from "react";
import './img-displayer.css'

function ImageDisplayerComponent() {
  return ( <>

        <div class="imgDisplayerWrapContainer">
          <div class="containter-img-displayer-1">
            <div className="img-displayer-container">
              <div className="img-txt-wrap">
                <h3 className="text txt1">COCINAS</h3>
                <img className="displayed-img image1" src="./Images/Hoteles.svg"/>
              </div>
              <div className="img-txt-wrap2">
                 <h3 className="txt2">CAFETERIAS</h3>
                 <img className="displayed-img image3" src="./Images/Caferia.svg"/>
          
              </div>
              <div className="img-txt-wrap">
                <h3 className="txt1">CARNICERIAS</h3>
                <img className="displayed-img image4" src="./Images/Carnicerias.svg"/>
          
              </div>
              <div className="img-txt-wrap2">
                <h3 className="txt2">PANADERIAS</h3>
                <img className="displayed-img image5" src="./Images/Panaderia.svg"/>
          
              </div>
              <div className="img-txt-wrap">
                <h3 className="txt1">SUPERMERCADOS Y ABARROTES</h3>
                <img className="displayed-img image6" src="./Images/SuperMercadoYAbarrotes.svg"/>
          
              </div>
            {/* <div className="displayed-img img5"></div> */}
                  </div>
          </div>
        </div>

    </>
  );
}

export default ImageDisplayerComponent;
